import routes from "../routes/Services.routes";
import axios from "axios";

function isSuccessfulDeleteResponse(res) {
  if (!res || res.status < 200 || res.status >= 300) return false;
  const d = res.data;
  if (d == null || d === "") return true;
  if (typeof d === "string") {
    const t = d.trim();
    if (t.startsWith("<")) return false;
    if (/suspended|account suspended/i.test(t)) return false;
    return true;
  }
  if (typeof d === "object") {
    if (d.success === false || d.error) return false;
    return true;
  }
  return false;
}

export default async function removeItemFromCart(itemOrId, setCount) {
  const idCandidates = [];

  if (typeof itemOrId === "string") {
    idCandidates.push(itemOrId);
  } else if (itemOrId) {
    idCandidates.push(
      itemOrId._id,
      itemOrId.item_id,
      itemOrId.cart_id,
      itemOrId.cartId,
      itemOrId.course_id,
      itemOrId.event_id
    );
  }

  const uniqueIds = [...new Set(idCandidates.filter(Boolean))];

  if (uniqueIds.length === 0) {
    return { status: 400, message: "Failed to delete: invalid item id." };
  }

  const headers = {
    token: localStorage.getItem("token"),
  };

  const removeBase = routes.RemoveFromCart.replace(/\/+$/, "");
  let lastError = null;

  const attemptDelete = async (request) => {
    try {
      const res = await request();
      if (!isSuccessfulDeleteResponse(res)) {
        lastError = {
          response: {
            status: 502,
            data: { message: "Unexpected response while removing item." },
          },
        };
        return null;
      }
      const deleted =
        typeof res.data === "object" && res.data != null
          ? res.data.deletedCount
          : undefined;
      setCount(deleted != null ? deleted : 1);
      const msg =
        typeof res.data === "object" && res.data != null && res.data.message
          ? res.data.message
          : "Course deleted successfully.";
      return { status: 200, message: msg };
    } catch (err) {
      lastError = err;
      return null;
    }
  };

  const buildAttempts = (id) => {
    const encoded = encodeURIComponent(String(id));
    const postBodies = [
      { _id: id },
      { id },
      { cart_id: id },
      { cartId: id },
      { course_id: id },
      { event_id: id },
    ];

    return [
      () => axios.delete(routes.RemoveFromCart + encoded, { headers }),
      () => axios.delete(`${removeBase}/${encoded}`, { headers }),
      () => axios.delete(removeBase, { headers, data: { _id: id } }),
      () => axios.delete(removeBase, { headers, data: { id } }),
      () => axios.delete(removeBase, { headers, data: { item_id: id } }),
      () => axios.delete(removeBase, { headers, data: { course_id: id } }),
      () => axios.delete(removeBase, { headers, data: { event_id: id } }),
      () => axios.delete(removeBase, { headers, params: { id } }),
      () => axios.delete(removeBase, { headers, params: { _id: id } }),
      () => axios.delete(`${removeBase}?id=${encoded}`, { headers }),
      ...postBodies.map(
        (body) => () => axios.post(removeBase, body, { headers })
      ),
      ...postBodies.map(
        (body) => () => axios.post(`${removeBase}/${encoded}`, body, { headers })
      ),
    ];
  };

  for (let i = 0; i < uniqueIds.length; i += 1) {
    const attempts = buildAttempts(uniqueIds[i]);
    for (let j = 0; j < attempts.length; j += 1) {
      const response = await attemptDelete(attempts[j]);
      if (response) return response;
    }
  }

  return {
    status: lastError?.response?.status || 400,
    message:
      lastError?.response?.data?.message ||
      lastError?.message ||
      "Failed to delete item.",
  };
}
